import { makeStyles } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import Tippy from '~components/tippy';
import Typography from '~components/typography';
import { CircleDetail } from '~svg-components';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      ...theme.flex.center,
      justifyContent: 'flex-end',
      textAlign: 'right',
      marginTop: 4,

      '& svg': {
        verticalAlign: 'middle',
        width: 12,
        height: 12,
      },
    },
    enternalIdWrap: {
      display: 'grid',
      columnGap: 8,
      gridTemplateColumns: 'auto auto',
    },
    externalIdLabel: {
      ...theme.typography.body2,
      color: theme.colors.greyCc,
    },

    externalIdContent: {
      ...theme.typography.body2,
      color: theme.colors.white,
    },
  }),
  { name: 'ExternalIdChip' }
);

function ExternalIdChip({ hideTooltip, cardId, className, externalIds }) {
  const { t } = useTranslation('global-search');
  const classes = useStyles();

  const renderExternalIdTooltip = () => (
    <div className={classes.enternalIdWrap}>
      {externalIds.map(
        (item, index) =>
          item.value && (
            <Fragment key={index}>
              <span className={classes.externalIdLabel}>{item.labelName}</span>
              <span>{item.value}</span>
            </Fragment>
          )
      )}
    </div>
  );

  const hasExternalIds = externalIds && externalIds.findIndex((item) => item.value) !== -1;

  return (
    <div className={classnames(classes.root, className)} key={cardId}>
      <Typography variant="caption" themeColor="grey99">
        {t('id')} {cardId}
      </Typography>
      {hasExternalIds && !hideTooltip && (
        <Tippy theme="tooltip" trigger="click" content={renderExternalIdTooltip()}>
          <CircleDetail style={{ marginLeft: 4 }} />
        </Tippy>
      )}
    </div>
  );
}

ExternalIdChip.prototype = {
  hideTooltip: PropTypes.bool,
  cardId: PropTypes.string.isRequired,
  className: PropTypes.string,
  externalIds: PropTypes.array,
};

ExternalIdChip.defaultProps = {
  hideTooltip: false,
  className: '',
};

export default ExternalIdChip;
